<template>
  <div>
    <v-container grid-list-md>
      <v-layout justify-center>
        <v-flex xs12 md6 v-if="checkpoint === null">
          <v-card>
            <v-card-title primary-title>
              <h2 class="display-1 mb-0">Login</h2>
            </v-card-title>
            <v-card-text>
              <v-text-field label="Password" v-model="tokenField" clearable></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="login()">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 v-else>
          <v-card>
            <v-card-title primary-title>
              <h2 class="display-1 mb-0">Versorgungspunkt {{ checkpoint.title }}</h2>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12>Es sind noch {{ participantsRunning }} Personen auf der Strecke</v-flex>
                <v-flex xs12 md6><v-text-field label="Startnummer" v-model="startNumber" clearable clear-icon="fal fa-times" type="number"></v-text-field></v-flex>
                <v-flex xs12 md6>
                  <v-btn @click="$vuetify.goTo(scrollTo, {offet: 20})">Suchen</v-btn>
                  <v-btn @click="scanQrCode = true">QR-Code scannen</v-btn>
                </v-flex>
              </v-layout>

              <v-container grid-list-xl>
                <v-layout class="justify-center" row wrap v-if="scanQrCode === true">
                  <v-card flat>
                    <v-card-title>QR Code scannen</v-card-title>

                    <v-responsive aspect-ratio="1/1">
                      <qrcode-stream @decode="onDecode" :track="true" :torch="true"></qrcode-stream>
                    </v-responsive>
                    <p>{{ error }}</p>
                    <v-card-actions><v-btn @click="scanQrCode = false">Abbrechen</v-btn></v-card-actions>
                  </v-card>
                </v-layout>
                <v-layout row wrap v-else>
                  <v-flex xs12 mg6 lg4 xl3 v-for="participant in participantsSorted" :key="participant.id" :class="'start-number-' + participant.startNumber">
                    <v-card :class="{'canceled': hasParticipantCanceled(participant), 'finished': hasParticipantFinishedThisCheckpoint(participant)}">
                      <v-card-title>
                        <h2 class="display-4">{{ participant.startNumber }}</h2>
                      </v-card-title>
                      <v-card-text>
                        <h3 class="display-1">{{ participant.firstname }} {{ participant.lastname }}</h3>
                        <p>{{ getCategoryById(participant.category).title }}</p>
                        <p>Letzter VP: {{ participant.lastCheckpointTime }}</p>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn color="success" @click="setTime(participant)" v-if="!hasParticipantFinishedThisCheckpoint(participant) || hasParticipantCanceled(participant)">Zeit nehmen</v-btn>
                        <v-btn color="success" @click="setTime(participant)" v-else>{{ getCheckpointTimeOfParticipant(participant) }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="setCancel(participant)" v-if="!hasParticipantCanceled(participant)">Abbrechen</v-btn>
                        <v-btn color="error" @click="setCancel(participant)" v-else>{{ getCheckpointTimeOfParticipant(participant) }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-card-text>
            <v-card-actions>

            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import CheckpointService from "../services/CheckpointService";
  import TimeService from "../services/TimeService";
  import { QrcodeStream } from 'vue-qrcode-reader'


  export default {
    name: 'CheckpointPublic',
    components: {
      QrcodeStream
    },
    computed: {
      scrollTo () {
        return '.start-number-' + this.startNumber
      },
      participantsSorted() {
        let participantsRunning = [];
        let participantsFinished = [];
        let participantsCanceled = [];
        let participantsOpened = [];

        this.participants.forEach(participant => {
          if (this.checkpoint.categories.includes(participant.category) && (this.startNumber === null || participant.startNumber === this.startNumber)) {
            if (this.hasParticipantCanceled(participant) === true) {
              participantsCanceled.push(participant)
            } else if (this.hasParticipantFinishedThisCheckpoint(participant)) {
              participantsFinished.push(participant)
            } else if (participant.startNumber !== null) {
              participantsRunning.push(participant)
            } else {
              participantsOpened.push(participant)
            }
          }
        })

        this.participantsRunning = participantsRunning.length
        participantsRunning.sort((a, b) => {
          if (a.lastCheckpointTimestamp != null && b.lastCheckpointTimestamp != null) {
            return a.lastCheckpointTimestamp - b.lastCheckpointTimestamp
          } else if (a.lastCheckpointTimestamp != null) {
            return -1
          } else if (b.lastCheckpointTimestamp != null) {
            return 1
          }

          return a.startNumber - b.startNumber
        })
        participantsFinished.sort((a, b) => {
          return a.startNumber - b.startNumber
        })
        participantsCanceled.sort((a, b) => {
          if (a.startNumber === null) {
            return 1
          } else if (b.startNumber === null) {
            return -1
          }
          return a.startNumber - b.startNumber
        })
        return participantsRunning.concat(participantsFinished, participantsCanceled)
      },
    },
    props: {
      'token': String
    },
    data: function () {
      return {
        scanQrCode: false,
        checkpoint: null,
        tokenField: '',
        startNumber: null ,
        participantsRunning: 0,
        error: ''
      }
    },
    created () {
      if (this.token !== undefined) {
        this.loadCheckpoint()
      }
    },
    watch: {
      token: function() { // watch it
        this.loadCheckpoint()
      }
    },
    methods: {
      onDecode(value) {
        if (value.split(':')[0] === 'drussen') {
          this.startNumber = value.split(':').slice(-1) + '';
        }
        this.scanQrCode = false;

      },
      loadCheckpoint () {
        CheckpointService.getByToken(this.token).then((response) => {
          this.checkpoint = response.data.checkpoint
          this.participants = response.data.participants
          this.categories = response.data.categories
        })
      },
      login () {
        this.$router.push({name: 'checkpoint-public', params: {token: this.tokenField}})
      },
      setTime (participant) {
        TimeService.update(this.token, {
          participantId: participant.id,
          checkpointId: this.checkpoint.id,
          cancel: false
        }).then(() => {
          this.loadCheckpoint()
        })
      },
      setCancel (participant) {
        TimeService.update(this.token, {
          participantId: participant.id,
          checkpointId: this.checkpoint.id,
          cancel: true
        }).then(() => {
          this.loadCheckpoint()
        })
      },
      hasParticipantCanceled(participant) {
        if (participant !== undefined && participant.canceled === true) {
          return true
        }
        if (participant !== undefined && participant.timeEntries.length > 0) {
          return participant.timeEntries.find(time => time.checkpoint === this.checkpoint.id && time.canceled === true) !== undefined
        }
        return false
      },
      hasParticipantFinishedThisCheckpoint(participant) {
        if (participant !== undefined && participant.timeEntries.length > 0) {
          return participant.timeEntries.find(time => time.checkpoint === this.checkpoint.id && time.datetime !== null && time.canceled !== true) !== undefined
        }
        return false
      },
      getCheckpointTimeOfParticipant(participant) {
        if (participant.timeEntries.length > 0) {
          const time =  participant.timeEntries.find(time => time.checkpoint === this.checkpoint.id)
          if (time !== undefined && time.datetime !== null) {
            return time.datetime.substr(0, time.datetime.length - 3)
          }
          return 'Abgebrochen'
        }

        return 'Abgebrochen'
      },
      getCategoryById(id) {
        return this.categories.find(category => category.id === id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .canceled {
    background-color: #ffe9e5;
  }

  .finished {
    background-color: #c8e6c9;
  }
</style>
